module.exports = __webpack_public_path__ + "static/img/mIcon1@2x.62500f29.png";